<template>

    <div class="evaluation row">
        <div class="col-sm">
            <Header :evaluation_title="evaluation.title" :user="user" :preview="preview" @clicked-user="clickedUserHandler"/>

            <!-- The user info registration form -->
            <UserInformationRegistration
                    class="mb-5"
                    :userProvider="user_provider"
                    :serverFormErrors="registration_errors"
                    :notice="profile_edit_notice"
                    @save="saveRegistrationFormHandler"
                    v-if="registrationFormVisible"/>
            <!-- end the user info registration form -->

            <span v-if="!finished && !registrationFormVisible">

                <div v-if="preview" class="alert alert-warning"
                     role="alert"><h2>Attention: You are in preview mode</h2>
                </div>

                <div class="alert alert-info welcome-text" role="alert" v-if="evaluation.welcome_msg">
                  {{ evaluation.welcome_msg }}
                </div>

              <div v-show="(evaluation.can_choose_anonymity) && (evaluation.evaluation_type_id === 1)" class="text-left" style="padding:16px 1.25rem;">
                <div>
                  <span v-html="t('anonymous_evaluation_text_dual')"></span>
                  <br>
                </div>
               <div style="margin-top:8px;">
                    <label><input type="radio" v-model="user.anonymous" :value="1"> {{ t('evaluation_yes') }}</label>
               </div>
                <div>
                  <label><input type="radio" v-model="user.anonymous" :value="0">  {{ t('evaluation_no') }}</label>
                </div>
              </div>

                 <div v-if="preview">
                    <div v-for="section in sections" :key="section.id" style="margin-bottom:48px;">
                       <div class="text-left"  style="font-size:1.5em;font-weight:500;margin-bottom:16px;margin-top:16px;">
                       {{ section.title }}
                      </div>
                     <EvalQuestion :evaluation="evaluation" :questions="section.answers" :submitted="submitted"/>
                  </div>
                 </div>

                <form v-else @submit.prevent="onSubmit">

                  <div v-for="section in sections" :key="section.id" style="margin-bottom:48px;">
                    <div class="text-left" style="font-size:1.5em;font-weight:500;margin-bottom:16px;margin-top:16px;">
                     {{section.title}}
                    </div>
                     <EvalQuestion :evaluation="evaluation"  :questions="section.answers" :submitted="submitted"/>
                  </div>

                       <div class="footer">
                         <div class="has_error" style="padding-bottom:8px;" v-if="errors.items.length">
                           {{t('evaluation_required_fields_error')}}
                         </div>
                            <button class="btn btn-primary mb-5">{{t('send_in')}}</button>
                       </div>
                </form>
            </span>
            <div ref="feedback"></div>
            <div v-if="finished">
                <div v-if="evaluation.evaluation_type_id === 1" class="user_msg">
                    <span>{{evaluation.success_msg }}</span>
                    <div class="link" style="padding-top:20px" v-html="test_link"></div>
                </div>
                <div v-else>
                    <span v-if="test_approved === true" class="user_msg">{{evaluation.feedback_positive }}</span>
                    <div v-else style="display:flex ; align-items: center; flex-direction: column;" class="user_msg">
                        {{evaluation.feedback_negative}}
                        <button style="width: 140px" class="btn btn-primary" @click="reload">{{t('try_again')}}</button>
                    </div>
                </div>

                <!-- correct and wrong answers receipt -->


                <EvalQuestionReceipt :evaluation="evaluation" :questions="receipt.answers" v-if="receipt.answers" class="mt-3"></EvalQuestionReceipt>

            </div>
            <!--        </div>-->
            <!--        <footer class="footer">-->
            <!--            Footer-->
            <!--        </footer>-->
        </div>
    </div>

</template>

<script>
    import axios from 'axios'
    //import router from 'vue-router'

    import Header from "./Header";
    import EvalQuestion from './EvalQuestion.vue'
    import EvalQuestionReceipt from './EvalQuestionReceipt.vue'
    import UserInformationRegistration from './UserInformationRegistration.vue'


    export default {
        name: 'Evaluation',
        props: {
            evaluation: {},
            settings: {},
            user: {},
            sections: [],
            user_provider: {},
            preview: null,
            token: null,
            language_id: null,
            profile_edit_notice: ''

        },
        components: {
            Header,
            EvalQuestion,
            EvalQuestionReceipt,
            UserInformationRegistration,
        },

        data() {
            return {
                finished: false,
                auth: false,
                //response: {},
                test_approved: false,
                submitted: false,
                test_link: null,

                receipt: {
                  answers: null
                },

                /*
                * Used by the registration form.
                * */
                validate_user_data: false,
                registration_errors: null,
                registration_completed: ($cookies.get(this.createRegistrationCompletedCookieKey()) === "true"),
                registration_form_visible : !($cookies.get(this.createRegistrationCompletedCookieKey()) === "true")
            }
        },
        computed : {
          registrationFormVisible : function(){
              /*
              * The form is visible only during Test, and when its not already been completed.
              * */
              let validate = (this.settings && this.settings.validate_user_data);
              let preview = this.preview;
              let completed = this.registration_completed;
              let is_test = this.evaluation.evaluation_type_id === 2;
              let is_visible = this.registration_form_visible;
              return (!preview && is_test && validate && (!completed || is_visible));
          }
        },
        methods: {
            t : function(key){
                return this.$phrasePlugin.translate(key);
            },
            createRegistrationCompletedCookieKey: function(){
                if(this.token && this.token.length > 30){
                    let token = this.token;
                    let substr = token.substr(token.length - 30);
                    return 'registration_completed.' + substr;
                }
                return 'registration_completed';
            },
            onSubmit: function () {
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.user.last_attempt.language_id = this.language_id;
                        axios({
                            method: 'put',
                            url: 'user/evaluation/' + this.evaluation.uuid_hex + '/' + this.token,
                            data: {
                              user : this.user //this.user.last_attempt
                            },
                        }).then(function (response) {
                            //todo: if success
                            this.test_approved = response.data.result;
                            this.finished = true;
                            this.test_link = response.data.link;
                            if(response.data.receipt){
                                this.receipt = response.data.receipt;
                                /*
                                * Scroll up to the top of the receipt
                                * */
                                if(this.$refs.feedback){
                                    if(document.documentElement.scrollIntoView){
                                        this.$nextTick(function () {
                                            this.$refs.feedback.scrollIntoView();
                                        });
                                    }
                                }
                            }
                        }.bind(this))
                            .catch(e => {
                                this.errors.push(e)
                            });
                    }
                });
            },

            /*
            * If the user clicks their email in the header component, we will toggle the
            * information registration form. This allows the user to later also do changes to their
            * information.
            * */
            clickedUserHandler : function(){
                if(this.registration_completed){
                    this.registration_form_visible = !this.registration_form_visible;
                }
            },

            /*
            * This handler is triggered when the registration form emits 'save' event.
            * It stores the current user data and sets 'registration_completed' to true
            * to hide the form and show the test.
            * */
            saveRegistrationFormHandler: function(){
                this.registration_errors = null;
                axios({
                    method: 'put',
                    url: 'user/' + this.evaluation.uuid_hex + '/' + this.token,
                    data: this.user_provider,
                }).then(function () {
                     this.registration_completed = true;
                     this.registration_form_visible = false;

                     /*
                     * Lets store the value so that they wont have to go through
                     * the confirm information process everytime they have to retake the test.
                     * */
                     $cookies.set(this.createRegistrationCompletedCookieKey(),  true);
                }.bind(this))
                .catch(e => {
                    /*
                    * Any server related validation errors will be shown in the registration form at the bottom.
                    * */
                    this.registration_errors = e.response.data;
                });
            },
            reload: function () {
                location.reload();
            }

        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/components/evaluation.scss";

</style>
